// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Vf","srOnly":"Wf"};